<template>
  <div class="banner">
    <div class="content-center">
      <div class="banner-title">打通合作通路，拓展业务边界</div>
      <div class="banner-subtitle">助力云企业与生态伙伴达成高效合作，推动产业协同升级与商业模式创新</div>
      <div class="primary-btn" @click="setCloudRegisterPopup(true)">免费注册云企业</div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions(['setCloudRegisterPopup']),
  }
};
</script>

<style lang="less" scoped>
.banner {
  height: 460px;
  background-image: url('@/assets/img/cooperation/Banner/background.png');
  background-size: cover;
  background-position: center;

  .content-center {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .banner-title {
      font-family: @font-bold;
      color: #fff;
      font-size: 32px;
      line-height: 65px;
      letter-spacing: 2px;
    }
    .banner-subtitle {
      margin-top: 13px;
      color: #fff;
    }
    .primary-btn {
      width: 232px;
      margin-top: 56px;
    }
  }
}
</style>
